const SUPPORTED_CHANGE_TYPES = ['series', 'repeats']

export { SUPPORTED_CHANGE_TYPES }
